import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation SuggestQuestionsForText(
    $customerId: ID!
    $allInstructionsData: JSON!
    $urlExtractions: [UrlExtractionInput!]
  ) {
    suggestQuestionsForText(
      customerId: $customerId
      allInstructionsData: $allInstructionsData
      urlExtractions: $urlExtractions
    ) {
      questions {
        text
        name
      }
    }
  }
`;

export const suggestQuestionsForText = ({ customerId, allInstructionsData, urlExtractions }) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, allInstructionsData, urlExtractions },
  }).then(({ data }) => getSingleProp(data));
};
